import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-to-bottom"
export default class extends Controller {
  connect() {
      this.scrollToBottom()
    
    // Set up a MutationObserver to watch for changes in the messages container
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, {
      childList: true, // Watch for added or removed child nodes
      subtree: true,  // Watch all descendants
    })
    }
    
    disconnect() {
      // Clean up the observer when the controller is disconnected
      this.observer.disconnect()
    }

    scrollToBottom() {
      this.element.scrollTop = this.element.scrollHeight
    }
}
